import { Box, styled } from "@mui/material";

export const StyledShipLights = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  width: "100%",
  alignItems: "center",
  padding: "2rem",
  ".quiz": {
    width: "60rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
    ".imageWrapper": {
      width: "30rem",
      img: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
      },
    },
    ".answers": {
      display: "flex",
      flexDirection: "column",
      width: "50%",
      gap: ".5rem",
      label: {
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
      },
    },
  },
  ".result": {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    ".header": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      h2: {
        width: "fit-content",
      },
    },
    ".resultAnswers": {
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
      maxHeight: "40rem",
      width: "60rem",
      overflow: "scroll",
      alignItems: "center",
      ".quizAnswer": {
        display: "flex",
        flexDirection: "column",
        width: "80%",
        border: `3px solid ${theme.color.main}`,
        padding: "1rem",
        borderRadius: "10px",
        boxSizing: "border-box",
        label: {
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
          borderRadius: "10px",
        },
        ".correct": {
            background: theme.palette.success.main,
        },
        ".wrong": {
            background: theme.palette.error.main,
        }
      },
    },
  },
}));
